import styled from "styled-components";
import UserMenu from "../../../components/account/UserMenu";
import { useContext } from "react";
import PersonalInfoCard from "../../../components/account/PersonalInfoCard";
import { AuthUserContext } from "../../../context/AuthUserContext";
import AddressCards from "../../../components/account/AddressCards";
import PersonalInformation from "./PersonalInformation";
import { useLocation } from "react-router-dom";
import i18next from "i18next";
import AddressBookForm from "../../../components/account/AddressBookForm";
import SavedCards from "../../../components/account/SavedCards";
import OrderHistory from "./OrderHistory";

const Container = styled.main`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    var(--primary-300) 0%,
    var(--bg-100) 260px
  );
  padding-top: calc(var(--navbar-height) + var(--navbar-mini));
  @media (min-width: 1040px) {
    min-height: 90vh;
    padding-top: calc(var(--navbar-height-desktop) + var(--navbar-mini));
  }
`;

const Wrapper = styled.div`
  width: 94%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  padding: var(--spacing-lg) 0 var(--spacing-xxl);

  @media (min-width: 1025px) {
    max-width: var(--max-width-container);
    padding: var(--spacing-xxl) 0;
  }
`;

const NavStickyBar = styled.div`
  position: sticky;
  top: calc(var(--navbar-height) + var(--navbar-mini));
  z-index: var(--zindex-sticky);
  @media (min-width: 1040px) {
    top: calc(var(--navbar-height-desktop) + var(--navbar-mini));
  }
`;

const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
`;

const AccountMain = () => {
  const { userProfile } = useContext(AuthUserContext);
  const location = useLocation();
  const language = i18next.language;

  const renderContent = () => {
    if (location.pathname === `/${language}/account/profile`) {
      return <PersonalInformation />;
    } else if (location.pathname === `/${language}/account/address-book`) {
      return <AddressCards />;
    } else if (location.pathname === `/${language}/account/orders`) {
      return <OrderHistory />;
    } else if (location.pathname === `/${language}/account/saved-cards`) {
      return <SavedCards />;
    } else if (location.pathname === `/${language}/account/address-book/new`) {
      return <AddressBookForm />;
    } else if (
      location.pathname.includes(`/${language}/account/address-book/edit`)
    ) {
      return <AddressBookForm />;
    } else {
      return (
        <>
          <PersonalInfoCard />
          <AddressCards />
        </>
      );
    }
  };

  return (
    <Container>
      <Wrapper>
        <NavStickyBar>
          <UserMenu />
        </NavStickyBar>
        {userProfile && <ContentGrid>{renderContent()}</ContentGrid>}
      </Wrapper>
    </Container>
  );
};

export default AccountMain;
